var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7132 4.99994H46.5284C49.1206 4.99994 51.2416 7.12039 51.2416 9.71315V51.2867C51.2416 53.879 49.1203 55.9999 46.5284 55.9999H14.7132C12.1205 55.9999 10 53.8787 10 51.2867V9.71315C10 7.12049 12.1205 4.99994 14.7132 4.99994ZM17.4899 10.5052C19.0109 10.5052 20.2442 11.7382 20.2442 13.2595C20.2442 14.7811 19.0108 16.0138 17.4899 16.0138C15.9683 16.0138 14.7348 14.7807 14.7348 13.2595C14.7348 11.7378 15.9683 10.5052 17.4899 10.5052ZM24.1015 11.6989H46.507V14.8204H24.1015V11.6989ZM17.4899 21.9982C19.0109 21.9982 20.2442 23.2317 20.2442 24.7534C20.2442 26.275 19.0108 27.5077 17.4899 27.5077C15.9683 27.5077 14.7348 26.2746 14.7348 24.7534C14.7348 23.2317 15.9683 21.9982 17.4899 21.9982ZM24.1015 23.1928H46.507V26.3143H24.1015V23.1928ZM17.4899 33.4921C19.0109 33.4921 20.2442 34.7252 20.2442 36.2464C20.2442 37.7681 19.0108 39.0016 17.4899 39.0016C15.9683 39.0016 14.7348 37.7681 14.7348 36.2464C14.7348 34.7248 15.9683 33.4921 17.4899 33.4921ZM24.1015 34.6859H46.507V37.8074H24.1015V34.6859ZM17.4899 44.9852C19.0109 44.9852 20.2442 46.2183 20.2442 47.7395C20.2442 49.2612 19.0108 50.4938 17.4899 50.4938C15.9683 50.4938 14.7348 49.2608 14.7348 47.7395C14.7348 46.2179 15.9683 44.9852 17.4899 44.9852ZM24.1015 46.179H46.507V49.3005H24.1015V46.179Z",
    fill: "url(#paint0_linear_1591_47498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1591_47498",
    x1: 30.6208,
    y1: 19.3437,
    x2: 30.6208,
    y2: 40.6999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38EF7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentSummary);
export default __webpack_public_path__ + "static/media/StudentSummary.1f44f6b4b11bd072b171db36dbf400d0.svg";
export { ForwardRef as ReactComponent };